import { jsx as m, jsxs as v } from "../../_virtual/jsx-runtime.mjs";
import * as l from "react";
import { reoTabChild as A, reoTabChildLabel as E, active as N, reoTabFather as F, vertical as L, fatherActive as R, reoTabChildrenWrapper as b, reoTabTree as j, reoTabFatherLabel as D, reoTabChildren as H, reoTabsBarAnimated as K } from "./css/ReoTabs.mjs";
import r from "../../depend/classnames/index.mjs";
import { getValByDef as T } from "../../utils/getValByDef.mjs";
const V = (e) => {
  var u, f;
  const n = l.useMemo(() => {
    var a;
    return T((a = e.optionName) == null ? void 0 : a.value, "value");
  }, [(u = e.optionName) == null ? void 0 : u.value]), d = l.useMemo(() => {
    var a;
    return T((a = e.optionName) == null ? void 0 : a.label, "label");
  }, [(f = e.optionName) == null ? void 0 : f.label]), i = l.useMemo(() => {
    const a = [];
    for (const c of e.options)
      for (const o of c.children)
        a.push([c[n], o[n]]);
    return a;
  }, [e.options, n]), t = l.useMemo(() => i.find((a) => a[1] === e.active), [i, e.active]), g = l.useCallback((a) => {
    var s;
    const c = a.target, o = i.find((h) => h[0] === c.dataset.value);
    (s = e.onChange) == null || s.call(e, o[1]);
  }, [i, e]), y = l.useCallback((a) => {
    var s;
    const c = a.target, o = i.find((h) => h[1] === c.dataset.value);
    (s = e.onChange) == null || s.call(e, o[1]);
  }, [i, e]), B = l.useCallback(
    (a) => r(
      e.tabBarClassName,
      A,
      E,
      a === (t == null ? void 0 : t[1]) ? N : null
    ),
    [t, e.tabBarClassName]
  ), k = l.useCallback(
    (a) => r(F, L, a === (t == null ? void 0 : t[0]) ? R : null),
    [t]
  ), [x, M] = l.useState({
    height: "",
    top: ""
  });
  l.useEffect(() => {
    const a = document.getElementsByClassName(`${N}`)[0];
    a && M({
      height: `${a.scrollHeight}px`,
      top: `${a.offsetTop}px`
    });
  }, [t]);
  const C = l.useRef([]);
  l.useEffect(() => {
    const a = document.getElementsByClassName(b);
    for (const c of a)
      C.current.push(c.scrollHeight);
  }, []);
  const S = l.useMemo(
    () => ({
      "--color": e.color,
      "--hover-color": e.hoverColor,
      "--active-color": e.activeColor,
      ...e.style
    }),
    [e.activeColor, e.color, e.hoverColor, e.style]
  );
  return e.options.length ? /* @__PURE__ */ m(
    "div",
    {
      className: r(e.className, j),
      style: S,
      children: e.options.map((a, c) => /* @__PURE__ */ v(
        "div",
        {
          className: k(a[n]),
          children: [
            /* @__PURE__ */ m(
              "div",
              {
                "data-value": a[n],
                className: D,
                onClick: g,
                children: a[d]
              }
            ),
            /* @__PURE__ */ m(
              "div",
              {
                className: b,
                style: {
                  height: a[n] === (t == null ? void 0 : t[0]) ? `${C.current[c]}px` : "0px"
                },
                children: /* @__PURE__ */ v("div", { className: r(H, e.childrenClass, e.scrollContainerClassName ?? ""), children: [
                  a.children.map((o) => /* @__PURE__ */ m(
                    "div",
                    {
                      "data-value": o[n],
                      onClick: y,
                      className: B(o[n]),
                      style: e.tabBarStyle,
                      children: o[d]
                    },
                    o[n]
                  )),
                  /* @__PURE__ */ m(
                    "div",
                    {
                      className: r(K, e.activeLineClassName ?? ""),
                      style: x
                    }
                  )
                ] })
              }
            )
          ]
        },
        a[n]
      ))
    }
  ) : null;
};
V.displayName = "ReoTabTree";
export {
  V as default
};
//# sourceMappingURL=ReoTabTree.mjs.map
